(function() {
    'use strict'

    var pluginName = "previewVideo";
    var defaults = {
        /* some default options */
    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);    // merge contents of objects into first object
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init: function() {
            this.$element = $(this.element);
            this.$video = $('.js-preview-video', this.element);
            
            if (this.$video.length) {
                this.video = this.$video.get(0);

                this.bindEvents();
            }
        },

        playVideo: function() {
            this.video.play();
        },

        stopVideo: function() {
            this.video.pause();
        },

        // EVENTS
        bindEvents: function() {
            if (window.matchMedia) {
                if (window.matchMedia('only screen and (min-width: 901px)').matches) {
                    this.$element.on('mouseenter', this.playVideo.bind(this));
                    this.$element.on('mouseleave', this.stopVideo.bind(this));
                }
            }
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());